module.exports = __webpack_public_path__ + "img/rank_grad_bg.65943be7.png";